import AppErrorBoundary from "./Refactor/components/ErrorBoundary";
import {
  Footer,
  FrameBody,
  Header,
  SubHeader,
  Wait
} from "@npd-ng/adp-benchmark";
import ModeSelectionView from "./Refactor/views/ModeSelectionView";
import AppHeader from "./Refactor/components/AppHeader";
import { useInitilizeService } from "./Refactor/hooks/useInitilizeService";
import ErrorView from "./Refactor/views/ErrorView";
import DeviceReadinessView from "./Refactor/views/DeviceReadinessView";
import UpdaterView from "./Refactor/views/UpdaterView";
import SetupCodeValidationView from "./Refactor/views/SetupCodeValidationView";
import WarningView from "./Refactor/views/WarningView";
import ConnectionCheckView from "./Refactor/views/ConnectionCheckView";
import RedirectionView from "./Refactor/views/RedirectionView";
import ErrorLoadinfView from "./Refactor/views/ErrorLoadingView";
import StressTestDisconnectedView from "./Refactor/views/StressTestDisconnectedView";
import HardwareCheckFailureView from "./Refactor/views/HardwareCheckFailureView";
import { useAppState } from "./Refactor/hooks/useAppState";
import { useStateContext } from "./Refactor/hooks/useStateContext";
import { actions, eNAEPComponents } from "./Refactor/state";
import { useServiceWorkerPrecacheValidation } from "./Refactor/hooks/useServiceWorkerValidation";
import { environment } from "./Refactor/util";
import { useDedupEffect } from "./Refactor/util/useDedupEffect";
import { useSuppressKeyboardZoom } from "./Refactor/hooks/useSupressKeyboardZoom";
import { useNetworkService } from "./Refactor/hooks/useNetworkService";
import { useReducer, useRef } from "react";
import { headerReducer, initialHeaderState } from "./Refactor/state/Reducers";
function App() {
  const { state, dispatch } = useAppState();
  useInitilizeService(dispatch, state);
  useSuppressKeyboardZoom();
  const cacheValidationStarted = useRef(false);
  const [headerState, dispatchHeader] = useReducer(headerReducer, initialHeaderState);
  const {initNetworkResolution} = useNetworkService(dispatch,dispatchHeader);
  
  const getCurrentView = () => {
    switch (state.appState.currentView) {
      case "ModeSelectionsView":
        return <ModeSelectionView />;
      case "WaitView":
        return <ConnectionCheckView />;
      case "ErrorView":
        return <ErrorView />;
      case "WarningView":
        return <WarningView />;
      case "DeviceValidationView":
        return <DeviceReadinessView />;
      case "UpdaterView":
        return <UpdaterView />;
      case "SetupCodeValidationView":
        return <SetupCodeValidationView />;
      case "RedirectionView":
        return <RedirectionView />;
      case "StressTestDisconnectedView":
        return <StressTestDisconnectedView/>
      case "HardwareCheckFailureView":
        return <HardwareCheckFailureView/>
    }
  };
  useDedupEffect(() => {
    initNetworkResolution();
  },[])
  useDedupEffect(() => {
    if(state.cacheValidation.validationStatus==="InProgress"){
      cacheValidationStarted.current = true;
    }
  },[cacheValidationStarted])
  return (
    <AppErrorBoundary hasError={false}>
      {state.appState.currentView !== "LoadingView" &&
        state.appState.currentView !== "LoadingErrroView" && (
          <>
            <AppHeader dispatch={dispatch} state={state} headerState={headerState} dispatchHeader={dispatchHeader}/>
            <SubHeader
              releaseVersion={{
                title: state.staticContent?.versionLabel as string,
                version: state.appState.releaseVersion as string,
                versionColors: state.appState.configuration
                  ?.versionColors as [],
                versionBorderColors: state.appState.configuration
                  ?.versionBorderColors as [],
              }}
              deviceInfo={{
                deviceLabel: state.staticContent?.deviceLabel as string,
                deviceId: state.deviceState.deviceId as string,
                deviceType: state.staticContent?.title as string,
              }}
            />
            {getCurrentView()}
          </>
        )}
      {state.appState.currentView === "LoadingView" && (
        <>
          <Header />
       
         <FrameBody>
          <div className="loadingWaitview" style={{marginTop:"20vh"}}>
            <Wait title="Loading..."/>
          </div>
            {state.cacheValidation.validationStatus==="InProgress" && !cacheValidationStarted.current && (
        <CachedResourceValidations
          {...{
            adp: state.serviceWorkers?.find((sw) => {return sw.appCode === eNAEPComponents.ADP})?.serverVersion,
            sci: state.serviceWorkers?.find((sw) => {return sw.appCode === eNAEPComponents.SCI})?.serverVersion,
            adc: state.serviceWorkers?.find((sw) => {return sw.appCode === eNAEPComponents.ADC})?.serverVersion,
          }}
        />
      )}
          </FrameBody>
        </>
      )}
      {state.appState.currentView === "LoadingErrroView" && (
        <>
          <ErrorLoadinfView/>
        </>
      )}
      <Footer primary={true} />
    </AppErrorBoundary>
  );
  
function CachedResourceValidations(versions: {
  adp: string | undefined;
  sci: string | undefined;
  adc: string | undefined;
}) {
  const {state, dispatch } = useStateContext();
  const cacheValidationConfig = state.appState.configuration?.localCacheValidation
  async function resetSW() {
    let promises = [];
    const regs = await navigator.serviceWorker.getRegistrations();
    for (const reg of regs) {
      promises.push(reg.unregister());
    }
    await Promise.all(promises).finally(() => {
      dispatch(actions.createUpdatePreChacheValidationStatusAction({validationStatus:"Failed",
      validationDetails:`Reseting service workers and reloading window`})); 
      setTimeout((()=>{
        window.location.reload();
      }),2000);
    });
  }

  async function handleIncorrectVersion(
    version: string | undefined,
    expectedVersion: string | undefined,
    appName: eNAEPComponents
  ) {
    console.error(
      `You are running an outdated version of ${appName}! Expected version ${expectedVersion} -- you are running version ${version}!`
    );
    dispatch(actions.createUpdatePreChacheValidationStatusAction({validationStatus:"Failed",
    validationDetails:`Device is running an outdated version of ${appName}! Expected version ${expectedVersion} -- device is running version ${version}!`})); 
    dispatch(actions.createUpdateServiceWorkerDetailsAction({appCode:appName,cachedVersion:version}));
     //TODO - prevent going into infinite reset
    //await resetSW();
  }
  async function handleSWVersion(
    version: string | undefined,
    appName: eNAEPComponents
  ) {
    console.log('handleSWVersion',{appCode:appName,cachedVersion:version});
   //dispatch(actions.createUpdateServiceWorkerDetailsAction({appCode:appName,cachedVersion:version}));
  }
  async function handlePrecacheFailure(
    expectedVersion: string | undefined,
    appName: string,
    manifestUrls: string[],
    failedUrls: string[]
  ) {
    console.error(
      `Precache failure for app ${appName}. Reaching this error means you are running app version ${expectedVersion}.\n`,
      `Precache urls were ${manifestUrls}.\n`,
      `Failed to precache the following urls: ${failedUrls}`
    );
    onError(`Precache failure for app ${appName}.
    Reaching this error means you are running app version ${expectedVersion},
    Precache urls were ${manifestUrls},Failed to precache the following urls: ${failedUrls}`); 
    //TODO - prevent going into infinite reset
    await resetSW();
  }

  // Called when precacheFailure is set to true
  function onError(errorMessage: string) {
    console.error(`Failed with error message : \n`, errorMessage);
    dispatch(actions.createUpdatePreChacheValidationStatusAction({validationStatus:"Failed",
    validationDetails:`Failed with error message : ${errorMessage}`})); 
    dispatch(actions.createSetViewAction("LoadingErrroView"));
  }

  const currentPath = window.location.href.replace("index.html", "");
  const [isADPPrecacheComplete, isADPPrecacheFailure] =
    useServiceWorkerPrecacheValidation(
      `${currentPath}`,
      versions.adp,
      (version: string) => handleSWVersion(version,eNAEPComponents.ADP),
      (version: string) => handleIncorrectVersion(version, versions?.adp, eNAEPComponents.ADP),
      (manifestUrls: string[], failedUrls: string[]) =>
        handlePrecacheFailure(versions?.adp, eNAEPComponents.ADP, manifestUrls, failedUrls),
      onError,
      { pollingIntervalMs: cacheValidationConfig?.pollingIntervalMs || 2000
        , maxRetryAttempts: cacheValidationConfig?.maxRetryAttempts || 30}
    );
  const [isSCIPrecacheComplete, isSCIPrecacheFailure] =
    useServiceWorkerPrecacheValidation(
      `${environment.resolveENAEPDomain()}/login/`,
      versions.sci,
      (version: string) => handleSWVersion(version,eNAEPComponents.SCI),
      (version: string) => handleIncorrectVersion(version, versions?.sci, eNAEPComponents.SCI),
      (manifestUrls: string[], failedUrls: string[]) =>
        handlePrecacheFailure(versions?.sci,  eNAEPComponents.SCI, manifestUrls, failedUrls),
      onError,
      { pollingIntervalMs: cacheValidationConfig?.pollingIntervalMs || 2000
        , maxRetryAttempts: cacheValidationConfig?.maxRetryAttempts || 30}
    );
  const [isADCPrecacheComplete, isADCPrecacheFailure] =
    useServiceWorkerPrecacheValidation(
      `${environment.resolveENAEPDomain()}/ade/`,
      versions.adc,
      (version: string) => handleSWVersion(version,eNAEPComponents.ADC),
      (version: string) => handleIncorrectVersion(version, versions.adc, eNAEPComponents.ADC),
      (manifestUrls: string[], failedUrls: string[]) =>
        handlePrecacheFailure(versions.adc, eNAEPComponents.ADC, manifestUrls, failedUrls),
      onError,
      { pollingIntervalMs: cacheValidationConfig?.pollingIntervalMs || 2000
        , maxRetryAttempts: cacheValidationConfig?.maxRetryAttempts || 30}
    );   
    useDedupEffect(() => {
    if (
      isADPPrecacheComplete &&
      isSCIPrecacheComplete &&
      isADCPrecacheComplete
    ) {
      dispatch(actions.createUpdatePreChacheValidationStatusAction({validationStatus:"Complete",
      validationDetails:`All cached resources are up to date`})); 
      dispatch(actions.createSetViewAction( state.sessionState.networkConnectionState!=="online" 
      ? "ModeSelectionsView" : "UpdaterView"));
    }
    if (isADPPrecacheFailure || isSCIPrecacheFailure || isADCPrecacheFailure) {
      dispatch(actions.createSetViewAction("LoadingErrroView"));
    }
   
  }, [
    isADPPrecacheComplete,
    isSCIPrecacheComplete,
    isADCPrecacheComplete,
    isADPPrecacheFailure,
    isSCIPrecacheFailure,
    isADCPrecacheFailure,
  ]);
  return null;
}

}


export default App;
